import React, {useState,useRef, useEffect} from 'react'
import styles from './variants.scss'
import { generateSku, getMatchedUOM, Regex } from '../../../utills'
import InputWithMovingLabel from 'jd-library/InputWithMovingLabel'
import FormSwitch from 'jd-library/FormSwitch';
import toastMessageActions from 'jd-library/toastMessageActions';
import { connect } from 'react-redux';
import ImageViewUpload from '../../../common/product-image/ImageViewUpload';
import { setVariantProductData,setVariantCorrection } from '../../../actions/variants';
import UOMSliderWrapper from '../UOMSliderWrapper';
import { updateEditProductDetail } from '../../../actions/products';
import UnitCount from '../unit-Count/UnitCount';
import SpecificTimeDuration from '../specific-time-duration/SpecificTimeDuration';
import InventoryBatches from '../../InventoryBatches/InventoryBatches';
import StockReorder from '../stock-reorder/StockReorder';

const VariantProductRow = (props) => {
    const [toggleInventory, setInventory] = useState(false);
    const [toggleNewInventory, setNewInventory] = useState(false);
    const [leftSectionRef, setLeftSectionRef] = useState(null);
    const [showStockReorder, toggleStockReorder] = useState(false);
    const sliderRef = useRef(null);
    const variantLength = props.variantData.length;
    const isCorrector = props.session.user.loggedUser?.subType === "CORRECTOR";
    const fillSku = () => {
        generateSku(props.session.token).then((res) => {
            props.setProductData({...props.productData,sku: res.data.sku}, props.index)
        }).catch((error) => {
        })
    }

    useEffect(() => {
        if(props.productId != 'ADD_PRODUCT' && props.isService && !props.productData?.specificDurationUnit && props.unitOfMeasurement.val == 'stds') {
            props.setProductData({...props.productData,specificDurationUnit: props.productList[0]?.specificDurationUnit},props.index)
        }
    },[])
    const getVariantString = (hideOverflow) => {
        let str = [];
        if(!props.variantInfo){
            return '';
        }
        for(let i=0;i<props.variantInfo.length;i++){
            str.push(<span className={styles['variant-type-info']}>
                <span className={styles['variant-type']}>{Object.keys(props.variantInfo[i])[0]}</span>: <span className={styles['variant-option']}>{props.variantInfo[i][Object.keys(props.variantInfo[i])[0]]}</span>{i==props.variantInfo.length-1 ? "" : <span className={styles['vertical-divider']}> | </span>}
            </span>)
        }
        return hideOverflow ? <div className={styles['header-text-overflow']}>{str}</div> : str;
    }

    const onImageClick = (index) => {
        props.setImageSlider({
            selImageIndex: index,
            productIndex: props.index,
            show: true
        })
    }

    const getImageMarkup = () => {
        const popoverTarget = leftSectionRef?.children[0]?.children[0];
        const checkPosition = popoverTarget && popoverTarget.getBoundingClientRect().top > (window.innerHeight * 0.45) ? 'top' : 'bottom';
        const onAddClickCB = () => {
            let variantData = [...props.variantData];
            if(variantData.length && variantData[props.index]){
                variantData[props.index] = {...variantData[props.index],errors: {...variantData[props.index].errors,imageUrlArr:''}};
                props.setVariantProductData(variantData);
            }
            props.setImageIndex(props.index);

        }
        if(!props.productData.imageUrlArr.length){
            return(
                <div className={styles['image-section-holder']}>
                    <ImageViewUpload
                        imageUrlArr={props.productData.imageUrlArr}
                        session={props.session}
                        className={styles['variant-image']}
                        onAddClickCB={()=>onAddClickCB()}
                        pos={checkPosition}
                        showAddImageWithText
                        popoverTarget={popoverTarget}
                        popoverClass={styles['variant-popover']}
                        uploadOptionProps={props.uploadOptionProps}
                        productId={props.productId}
                        showError={props.productData.errors['imageUrlArr']}
                    />
                    <div className={styles['tiny-image-holder']}>
                        {props.productData.videoUrlArr.length ?
                            <>
                                <ImageViewUpload
                                    forVideo
                                    imageUrlArr={props.productData.videoUrlArr}
                                    className={styles['variant-image']}
                                    onAddClickCB={()=>props.setImageIndex(props.index)}
                                    customCB={()=>onImageClick(props.productData.imageUrlArr.length)}
                                    pos='bottom'
                                    productId={props.productId}
                                    uploadOptionProps={props.uploadOptionProps}
                                />
                                <ImageViewUpload
                                    imageUrlArr={props.productData.imageUrlArr}
                                    session={props.session}
                                    className={styles['variant-image']}
                                    onAddClickCB={()=>props.setImageIndex(props.index)}
                                    pos={checkPosition}
                                    popoverTarget={props.productData.imageUrlArr.length > 1?leftSectionRef?.children[0]?.children[1]?.children[2]:leftSectionRef?.children[0]?.children[2]?.children[1]}
                                    popoverClass={styles['variant-popover']}
                                    productId={props.productId}
                                    uploadOptionProps={props.uploadOptionProps}
                                />
                            </>:
                            <>
                                <ImageViewUpload
                                    imageUrlArr={props.productData.imageUrlArr}
                                    session={props.session}
                                    className={styles['variant-image']}
                                    onAddClickCB={()=>props.setImageIndex(props.index)}
                                    pos={checkPosition}
                                    popoverTarget={leftSectionRef?.children[0]?.children[1]?.children[0]}
                                    popoverClass={styles['variant-popover']}
                                    productId={props.productId}
                                    uploadOptionProps={props.uploadOptionProps}
                                />
                                <ImageViewUpload
                                    forVideo
                                    imageUrlArr={props.productData.videoUrlArr}
                                    className={styles['variant-image']}
                                    onAddClickCB={()=>props.setImageIndex(props.index)}
                                    customCB={()=>onImageClick(props.productData.imageUrlArr.length)}
                                    pos={checkPosition}
                                    popoverTarget={leftSectionRef?.children[0]?.children[1]?.children[1]}
                                    popoverClass={styles['variant-popover']}
                                    productId={props.productId}
                                    uploadOptionProps={props.uploadOptionProps}
                                />
                            </>
                        }
                    </div>
                </div>
            )
        }else{
            return(
                <div className={styles['image-section-holder']}>
                    <ImageViewUpload
                        imageUrlArr={props.productData.imageUrlArr}
                        imageListIndex={0}
                        session={props.session}
                        className={styles['variant-image']}
                        customCB={()=>onImageClick(0)}
                        productId={props.productId}
                        uploadOptionProps={props.uploadOptionProps}
                    />
                    <div className={`${styles['tiny-image-holder']}`}>
                        {props.productData.imageUrlArr.length > 1 ?
                        <ImageViewUpload
                            imageUrlArr={props.productData.imageUrlArr}
                            imageListIndex={1}
                            session={props.session}
                            className={styles['variant-image']}
                            remainingImages={props.productData.imageUrlArr.length > 2 ? props.productData.imageUrlArr.length-1 : null}
                            customCB={()=>onImageClick(1)}
                            productId={props.productId}
                            uploadOptionProps={props.uploadOptionProps}
                        /> : null}
                        {props.productData.videoUrlArr.length ?
                            <>
                                <ImageViewUpload
                                    forVideo
                                    imageUrlArr={props.productData.videoUrlArr}
                                    className={styles['variant-image']}
                                    onAddClickCB={()=>props.setImageIndex(props.index)}
                                    customCB={()=>onImageClick(props.productData.imageUrlArr.length)}
                                    pos='bottom'
                                    productId={props.productId}
                                    uploadOptionProps={props.uploadOptionProps}
                                />
                                {(props.productData.imageUrlArr.length < ((props.uploadOptionProps.isVariant || variantLength) ? 2 : 40)) ? <ImageViewUpload
                                    imageUrlArr={props.productData.imageUrlArr}
                                    isAddVariant={true}
                                    className={styles['variant-image']}
                                    session={props.session}
                                    onAddClickCB={()=>props.setImageIndex(props.index)}
                                    pos={checkPosition}
                                    popoverTarget={leftSectionRef?.children[0]?.children[1]?.children[1]}
                                    popoverClass={styles['variant-popover']}
                                    productId={props.productId}
                                    uploadOptionProps={props.uploadOptionProps}
                                /> : null}
                            </>
                        :
                            <>
                                {(props.productData.imageUrlArr.length < (props.uploadOptionProps.isVariant ? 2 : 40)) ? <ImageViewUpload
                                    imageUrlArr={props.productData.imageUrlArr}
                                    isAddVariant={true}
                                    className={styles['variant-image']}
                                    session={props.session}
                                    onAddClickCB={()=>props.setImageIndex(props.index)}
                                    pos={checkPosition}
                                    popoverTarget={props.productData.imageUrlArr.length > 1?leftSectionRef?.children[0]?.children[1]?.children[1]:leftSectionRef?.children[0]?.children[1]?.children[0]}
                                    popoverClass={styles['variant-popover']}
                                    productId={props.productId}
                                    uploadOptionProps={props.uploadOptionProps}
                                /> : null}
                                <ImageViewUpload
                                    forVideo
                                    imageUrlArr={props.productData.videoUrlArr}
                                    className={styles['variant-image']}
                                    onAddClickCB={()=>props.setImageIndex(props.index)}
                                    customCB={()=>onImageClick(props.productData.imageUrlArr.length)}
                                    pos={checkPosition}
                                    popoverTarget={props.productData.imageUrlArr.length > 1?leftSectionRef?.children[0]?.children[1]?.children[2]:leftSectionRef?.children[0]?.children[1]?.children[1]}
                                    popoverClass={styles['variant-popover']}
                                    productId={props.productId}
                                    uploadOptionProps={props.uploadOptionProps}
                                />
                            </>
                        }
                    </div>
                </div>
            )
        }
    }

    const getFields = () => {
        return (
            !props.isService ? (
                <>
                    <div className={`${styles['triple-input-sec']} ${(props.productData.errors['quantity']?.length || props.productData.errors['mrp']?.length)?styles['err-found']:''} ${props.session.isReadOnly ? 'read-only-mode' : ''}`}>
                    <InputWithMovingLabel
                        input={{
                            value: props.productData.quantity || '',
                            onChange: e => {
                                if(regexObj['quantity'].test(e.target.value)){
                                    props.setProductData({...props.productData,quantity: e.target.value}, props.index)
                                }
                            },
                            onFocus: () => {props.productData.errors['quantity'] && props.hideError('quantity',props.index)},
                            type: "tel"
                        }}
                        label="Qty"
                        labelAlwaysUp
                        className={styles['left-input']}
                        errorMessage={props.productData.errors['quantity']}
                        errClass={styles['err-txt']}
                    />
                    <InputWithMovingLabel
                        input={{
                            value: props.productData.mrp || "",
                            onChange: e => {
                                if(regexObj['money'].test(e.target.value)){
                                    props.setProductData({...props.productData,mrp: e.target.value}, props.index)
                                }
                            },
                            onFocus: () => {props.productData.errors['mrp'] && props.hideError('mrp',props.index)},
                            type: "tel"
                        }}
                        label="MRP"
                        labelAlwaysUp
                        className={styles['middle-input']}
                        errorMessage={props.productData.errors['mrp']}
                        errClass={styles['err-txt']}
                    />
                    <InputWithMovingLabel
                        input={{
                            value: props.productData.sp || "",
                            onChange: e => {
                                if(regexObj['money'].test(e.target.value)){
                                    props.setProductData({...props.productData,sp: e.target.value}, props.index)
                                }
                            },
                            onFocus: () => {props.productData.errors['sp'] && props.hideError('sp',props.index)},
                            type: "tel"
                        }}
                        label="SP"
                        errorMessage={props.productData.errors['sp']?props.productData.errors['sp']:showWarning ? 'Higher than MRP' : ''}
                        errClass={styles['sp-warning']}
                        // warning={showWarning || props.productData.errors['sp']}
                        labelAlwaysUp
                        className={styles['right-input']}
                    />
                </div>
                <div className={styles['add-more']}
                    onClick={()=>props.setMoreDetails(props.index, getVariantString(true))}
                >
                    {props.isEdit && <i className='icon-editItem more-sec-icon'/>} {props.isEdit ? 'Edit Barcode & more' : (<><i className={`icon-plus ${!props.deviceData.isMobile? styles["iconPlus"]: ""}`}></i><span>Add Barcode & more</span> </>)}
                </div>
                </>
            ) :
            (
                <>
                    <div className={`${styles['triple-input-sec']} ${(props.productData.errors['actualPrice']?.length  ? styles['actual-err'] : props.productData.errors['discPrice']?.length ? styles['disc-err'] : '')} ${props.session.isReadOnly ? 'read-only-mode' : ''}`}>
                        <div className={`${styles['wrapper-tripple-input-sec']}`}>
                            <InputWithMovingLabel
                                input={{
                                    value: props.productData.actualPrice || '',
                                    onChange: (e) => {                                        
                                        if (regexObj["money"].test(e.target.value)) {
                                          props.setProductData(
                                            { ...props.productData, actualPrice: e.target.value },
                                            props.index
                                          );
                                           handleVariantCorrectionUpdate('actualPrice',props.index,props.productData.variantId || '', e.target.value);
                                        }
                                    },
                                    onFocus: () => {props.productData.errors['actualPrice'] && props.hideError('actualPrice',props.index)},
                                    type: 'tel'
                                }}
                                label="Actual Rs."
                                labelAlwaysUp
                                holderClass={styles['left-input']}
                                prepend={() => <span className="icon-currency" />}
                                hidePrependBar={true}
                                showPreTextWithoutFocus={true}
                                errorMessage={!!props.productData.errors['actualPrice']}
                                errClass={styles['err-txt']}
                            />
                            <InputWithMovingLabel
                                input={{
                                    value: props.productData.discPrice || '',
                                    onChange: e => {
                                        if(regexObj['money'].test(e.target.value)) {
                                            props.setProductData({...props.productData,discPrice: e.target.value},props.index)
                                           handleVariantCorrectionUpdate('discPrice',props.index,props.productData.variantId || '', e.target.value);
                                        }
                                    },
                                    onFocus: () => {props.productData.errors['discPrice'] && props.hideError('discPrice',props.index)},
                                    type: 'tel'
                                }}
                                label="Disc. Rs."
                                labelAlwaysUp
                                holderClass={styles['middle-input']}
                                prepend={() => <span className="icon-currency" />}
                                hidePrependBar={true}
                                showPreTextWithoutFocus={true}
                                errorMessage={!!props.productData.errors['discPrice']}
                                errClass={styles['err-txt']}
                            />
                            {/* <span className={styles['slash-text']}>/</span> */}
                            <InputWithMovingLabel
                                label='Unit'
                                disableMovingLabel={true}
                                rightIconClass={props?.unitOfMeasurement?.displayVal ? 'icon-HDRcross' : 'icon-Next'}
                                onRightIconClick={() => {
                                    if (props.unitOfMeasurement.displayVal) {
                                    let data = { ...props.unitOfMeasurement };
                                    data.value = "";
                                    if (!data.key) {
                                        data.key = "unitOfMeasurement";
                                    }
                                    props.updateEditProductDetail(data);
                                    } else {
                                        sliderRef.current.openCloseUOMSlider(true);
                                    }
                                }}
                                input={{
                                    value: props?.unitOfMeasurement?.displayVal || '',
                                    readOnly: true,
                                    onClick: () => sliderRef.current.openCloseUOMSlider(true)
                                }}
                                holderClass={styles['right-input']}
                            />
                        </div>
                        {props.productData.errors['actualPrice'] || props.productData.errors['discPrice'] ? 
                            <div className={styles['custm-err']}>
                                {props.productData.errors['actualPrice'] || props.productData.errors['discPrice']}
                            </div>
                        : null}
                    </div>
                    {(props.unitOfMeasurement.val == "Sess" || props.unitOfMeasurement.val == "Visit") ? 
                        <UnitCount 
                            uomDetails={props.unitOfMeasurement || ''}
                            showUnitCount= {['Sess','Visit'].includes(props.unitOfMeasurement.val)}
                            customDuration={props.productData.customDuration || ''}
                            isVariant={true}
                            unit={props.productData.uom || (props.productData.customDuration? '' : '1 '+props.unitOfMeasurement.val)}
                            updateUnit={(uom) => {
                                props.setProductData({...props.productData,uom: uom},props.index)
                                handleVariantCorrectionUpdate('newUom',props.index,props.productData.variantId || '', uom);
                            }}
                        /> : 
                    props.unitOfMeasurement.val == "stds" ?
                    <>
                        <SpecificTimeDuration
                            productInfo={props.productData}
                            isError={Boolean(props.productData.errors['specific'])}
                            updateEditProductDetail={(obj) => {
                                props.hideError('specific',props.index);
                                props.setProductData({...props.productData,[obj.key]: obj.value},props.index);
                            }}
                        />
                        {props.productData.errors['specific'] ? <div className={styles['custm-err']}>{props.productData.errors['specific']}</div>:null} 
                    </>: null
                    }
                </>
            ) 
        )
    }

    const regexObj = {
        money: Regex.priceRegex,
        quantity: /^\d{0,6}$/,
        sku: Regex.skuRegex
    }
    const showWarning = (props.productData.sp && props.productData.mrp && (Number(props.productData.sp) > Number(props.productData.mrp)))
    const hideInventorySlide = () => {
        setInventory(false);
        setNewInventory(false)
    }
    let isError = '';
    if(props.productData.errors['quantity'] || props.productData.errors['mrp'] || props.productData.errors['sp']){
        isError = true;
    }

    const onSelectUOM = (e, uom) => {
        const key = 'unitOfMeasurement';
        let updateArr = [
            {
              key,
              value: uom.val,
              uomType: uom.uomType,
            },
          ];
        handleVariantCorrectionUpdate('newUom', props.index, props.productData.variantId, `${props.productData.customDuration} ${uom.val}` )
        props.updateEditProductDetail(updateArr);
        sliderRef.current.openCloseUOMSlider(false);
    }

    const handleVariantCorrectionUpdate = (ipField, index, variantIdToFind, newValue) => {
        if(!isCorrector) {
            return;
        }
        const variantCorrection = { ...props.variantCorrection };
      
        // Ensure index is initialized
        if (!variantCorrection[index]) {
          variantCorrection[index] = [];
        } else {
          variantCorrection[index] = [...variantCorrection[index]];
        }
      
        let variantFound = false;
      
        const updatedVariants = props.savedVariantForCompare.map((variant) => {
          if (variant.variantId === variantIdToFind) {
            variantFound = true;
      
            const isModified = String(variant[ipField]) !== String(newValue);
      
            if (isModified) {
              if (!variantCorrection[index].includes(ipField)) {
                variantCorrection[index].push(ipField);
              }
            } else {
              variantCorrection[index] = variantCorrection[index].filter(field => field !== ipField);
            }
      
            return {
              ...variant,
              isModified,
            };
          }
      
          return variant;
        });
      
        // Handle case where variantId is not found (i.e., newly added variant)
        if (!variantFound) {
          
            if (String(newValue).trim() !== "") {
              // Add if not already there
              if (!variantCorrection[index].includes(ipField)) {
                variantCorrection[index].push(ipField);
              }
            } else {
              // Flush if empty string
              variantCorrection[index] = variantCorrection[index].filter(field => field !== ipField);
            }
          }

        props.setVariantCorrection(variantCorrection);
      };
      
    const updateAllDuration = (val) => {
        let tmpData = [...props.productList];
        tmpData = tmpData.map(cur => ({...cur,specificDurationUnit: val}));
        props.setAllProductData(tmpData);
    }

    return(
        <>
            <div className={`${styles['variant-row']} ${props.isService?styles['service-row']:''}`}>
                <div
                    className={styles['left-section']}
                    ref={r=> r && setLeftSectionRef(r)}
                >
                    {!props.isService ? getImageMarkup() : null}
                </div>
                <div className={styles['right-section']}>
                    <div className={styles['variant-parent']}>
                        <div className={styles['variant-info']}>{getVariantString()}</div>
                    </div>
                    {/* {!props.permissions.isMaintainProductSku && <InputWithMovingLabel */}
                    {getFields()}
                    {/* this is commented bcoz it going to next phase with development pending */}
                    {props.session.viaOmni && (props.isEdit && props.productData.batchCount > 1) ?
                        <div className={`${styles['stock-reorder']} ${styles['view-all-inventory']}`} onClick={() => setInventory(true)}>
                            <i className="icon-InventoryInvoice more-sec-icon"></i>View All Inventory Batches
                        </div> : null}
                    {/* {props.session.viaOmni && props.isEdit?
                    <div className={`${styles['stock-reorder']} ${styles['view-all-inventory']}`} onClick={() => setNewInventory(true)}>
                        <i className="icon-InventoryInvoice more-sec-icon"></i>Add New Inventory Batches
                    </div> : null} */}
                    {props.isEdit && props.session.viaOmni && (toggleInventory || toggleNewInventory) ? <InventoryBatches productId={props.productData.variantId} itemInfo={{...props.productData,productId:props.productData.variantId}} isVariant={true}  onHidden={hideInventorySlide} componentlabel={"Edit Inventory Batch"} addNew={toggleNewInventory} variantIndex={props.index} /> : null}
                    {props.isEdit && props.session.viaOmni && !props.isService && <div className={`${styles['stock-reorder']}`}
                        onClick={()=> toggleStockReorder(true)}
                    >
                        <i className='icon-Product more-sec-icon'/> View Stock Reorder Details
                    </div>}
                    {showStockReorder ? 
                    <StockReorder 
                        fromSingleVariant
                        currentVariantIndex={props.index}
                        onHiddenForVariant={() => toggleStockReorder(false)}
                    /> : null}
                    {props.session.user?.loggedUser?.userType==="AUDITOR" || props.isService ? null : <InputWithMovingLabel
                        key="skuId"
                        input={{
                            value: props.productData.sku || "",
                            onChange: e => {
                                if(regexObj['sku'].test(e.target.value)){
                                    props.setProductData({...props.productData,sku: e.target.value}, props.index);
                                    props.productList.map((cur,index) => {
                                        if(cur.errors['sku']){
                                            cur.errors['sku'] = '';
                                            props.setProductData(cur,index)
                                        }
                                    })
                                }
                            },
                            onFocus: () => {props.productData.errors['sku'] && props.hideError('sku',props.index)},
                        }}
                        inputGroupProps={{
                            rightSection: () => {
                                return (
                                    <div className="sku-icons">
                                        {!props.productData.sku && <i onClick={fillSku} className="icon-Generate"></i>}
                                    </div>
                                );
                            }
                        }}
                        label="SKU ID"
                        holderClass="sku-input"
                        errorMessage={props.productData.errors['sku']}
                    />}
                    <div className={styles['show-on-website']}>
                        Show on Website
                        <FormSwitch
                            checked={props.productData.showOnWebsite}
                            onClick={e => {
                                if(props.session.isReadOnly) return;
                                handleVariantCorrectionUpdate('showOnWebsite',props.index,props.productData.variantId || '', e.target.checked);

                                props.setProductData({...props.productData, showOnWebsite: e.target.checked}, props.index) 
                            }}
                            showToggleStatus={false}
                            className={styles['switch-button'] + ' ' +styles['read-only-mode-show-on-website']}
                        />
                    </div>
                </div>
            </div>
            <UOMSliderWrapper
              ref={sliderRef}
              uomType={props.isService
                  ? "serviceUOM"
                  : ""
              }
              onSelectUOM={onSelectUOM}
            />
        </>
    )
}

const mapStateToProps = (state,props) => {
    const uom = state.uom;
    let unitOfMeasurement = {};
    let product = state.products.editProduct;
    if (product.unitOfMeasurement) {
        unitOfMeasurement = getMatchedUOM(
          uom.productUOM,
          product.unitOfMeasurement
        );
      }
    if (!Object.keys(unitOfMeasurement).length) {
    unitOfMeasurement.displayVal = product.unitOfMeasurement;
    } 
    product.uomType =
    state.products.uomType || unitOfMeasurement.uomType || "";
    return{
        ...props,
        session: state.session,
        deviceData: state.deviceData,
        permissions: state.permissions,
        // isEdit: state.items.itemInfo.isEdit,
        productId: state.products.editProduct.productId,
        variantData: state.variants.variantProductData,
        isService: state.products.editProduct.categoryType == 'service',
        productInfo: product,
        unitOfMeasurement,
        savedVariantForCompare: state.products.editProduct.savedVariantForCompare,
        variantCorrection: state.variants.variantCorrection
    }
}

export default connect(mapStateToProps, {
    showToastMessage: toastMessageActions.showMessage,
    setVariantProductData,
    setVariantCorrection,
    updateEditProductDetail,
})(VariantProductRow)